document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-sustainability-video]');

    sections.forEach(function (section) {
        var iframe = section.querySelector('.sustainability-video__iframe');
        var coverImage = section.querySelector('.sustainability-video__image');
        var playButton = section.querySelector('.sustainability-video__play');

        if (!iframe) return;

        var hasStarted = false;

        var startPlayback = function () {
            if (hasStarted) return;
            hasStarted = true;

            section.classList.add('is-starting');

            // Esconde a imagem de capa e o botão de play
            if (coverImage) {
                coverImage.style.display = 'none';
            }
            if (playButton) {
                playButton.style.display = 'none';
            }

            // Mostra o iframe e adiciona autoplay
            iframe.style.display = 'block';
            var currentSrc = iframe.src;
            var newSrc = currentSrc.replace('autoplay=0', 'autoplay=1');
            iframe.src = newSrc;

            section.classList.remove('is-starting');
            section.classList.add('is-playing');
        };

        section.addEventListener('click', function (e) {
            if (!hasStarted) {
                e.preventDefault();
                startPlayback();
            }
        });
    });
});